import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, History, Calendar } from "lucide-react";
import { api } from "../lib/api";
import { PageHeader, Spinner, EmptyState } from "../components/UI";
import { fmtDate } from "../lib/utils";

export default function Visits() {
  const [visits, setVisits] = useState([]);
  const [estabs, setEstabs] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [v, e] = await Promise.all([
          api.get("/visits"),
          api.get("/establishments", { params: { limit: 500 } }),
        ]);
        setVisits(v.data.items || []);
        const map = {};
        for (const x of e.data.items || []) map[x.id] = x;
        setEstabs(map);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div>
      <PageHeader
        testid="visits-header"
        title="Visit history"
        subtitle="Every stop. Every conversation. Time-stamped."
        actions={
          <Link to="/visits/new" className="btn-primary" data-testid="new-visit-button">
            <Plus size={16} /> Log visit
          </Link>
        }
      />

      {loading ? (
        <Spinner />
      ) : visits.length === 0 ? (
        <EmptyState
          testid="empty-visits"
          icon={History}
          title="No visits yet"
          body="Start logging field visits to build a paper trail (and stronger pipeline)."
          action={<Link to="/visits/new" className="btn-primary"><Plus size={16} /> Log first visit</Link>}
        />
      ) : (
        <div className="card divide-y divide-brand-border" data-testid="visits-list">
          {visits.map((v) => {
            const e = estabs[v.establishment_id];
            return (
              <Link
                to={e ? `/establishments/${e.id}` : "#"}
                key={v.id}
                className="flex items-start gap-4 p-5 hover:bg-brand-muted/40 transition-colors"
                data-testid={`visit-row-${v.id}`}
              >
                <div className="w-10 h-10 rounded-full bg-brand-muted flex items-center justify-center text-brand-ink">
                  <Calendar size={16} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <div className="font-display text-lg text-brand-ink">{e?.name || "Unknown establishment"}</div>
                    {v.outcome && <span className="badge stage-qualified">{v.outcome}</span>}
                  </div>
                  <div className="text-xs text-brand-mutedFg">{fmtDate(v.visit_date)}</div>
                  <p className="text-sm text-brand-ink2 mt-1 line-clamp-2 whitespace-pre-wrap">{v.notes}</p>
                </div>
                {v.photos?.length > 0 && (
                  <div className="hidden sm:block w-16 h-16 rounded-xl overflow-hidden border border-brand-border shrink-0">
                    <img src={v.photos[0]} alt="" className="w-full h-full object-cover" />
                  </div>
                )}
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
